import styled from 'styled-components';
import { Background } from '../../Styles/globalstyle';

export const BackgroundCV = styled(Background)`
  .container {
    -webkit-box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.79);
    box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.79);
    margin-top: 2%;
    margin-bottom: 2%;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1%;
    @media (max-width: 480px) {
      overflow: hidden;
      max-width: 95%;
    }
  }
`;
